import script from "./BlockElementExists.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockElementExists.vue?vue&type=script&setup=true&lang=js"

import "./BlockElementExists.vue?vue&type=style&index=0&id=20d83969&lang=css"

const __exports__ = script;

export default __exports__